export const APP_TOGGLE_LANGUAGE = 'APP_TOGGLE_LANGUAGE';
